export default __webpack_public_path__ + "static/media/blueDots.33fc97d0.svg";